<template>
  <div class="wordcloud-container">
    <div class="cloud-box" ref="cloudEl" />
  </div>
</template>

<script>
import * as echarts from "echarts";
import wordcloud from "echarts-wordcloud";
export default {
  name: "Analysis",
  props: {
    wordcloudData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    wordcloudData(val) {
      if (val) {
        this.drawCloud(this.$refs.cloudEl, val);
      }
    },
  },

  data() {
    return {
      wordcloud: wordcloud,
      myChart: null,
      resizeObserver: null,
      wordData: [
        // { name: "无人驾驶", value: 352 },
        // { name: "区块链", value: 214 },
        // { name: "云计算", value: 534 },
        // { name: "物联网", value: 134 },
        // { name: "虚拟现实", value: 534 },
        // { name: "增强现实", value: 542 },
        // { name: "人工智能", value: 242 },
        // { name: "机器学习", value: 42 },
        // { name: "深度学习", value: 435 },
        // { name: "自然语言处理", value: 124 },
        // { name: "计算机视觉", value: 654 },
        // { name: "神经网络", value: 232 },
        // { name: "数据挖掘", value: 324 },
        // { name: "语音识别", value: 453 },
        // { name: "图像识别", value: 124 },
        // { name: "聊天机器人", value: 453 },
        // { name: "智能家居", value: 233 },
        // { name: "人脸识别", value: 123 },
        // { name: "量子计算", value: 212 },
        // { name: "智能制造", value: 241 },
        // { name: "语义分割", value: 414 },
        // { name: "知识图谱", value: 564 },
        // { name: "增量学习", value: 755 },
        // { name: "多模态学习", value: 229 },
        // { name: "迁移学习", value: 233 },
        // { name: "生成对抗网络", value: 124 },
        // { name: "强化学习", value: 65 },
        // { name: "人机交互", value: 199 },
        // { name: "机器人技术", value: 299 },
        // { name: "智能音箱", value: 454 },
        // { name: "智能医疗", value: 365 },
        // { name: "异常检测", value: 360 },
        // { name: "时间序列预测", value: 187 },
        // { name: "推荐系统", value: 360 },
        // { name: "情感分析", value: 460 },
        // { name: "机器翻译", value: 480 },
        // { name: "语音合成", value: 488 },
        // { name: "人脸生成", value: 51 },
        // { name: "图像风格转换", value: 99 },
        // { name: "实例分割", value: 120 },
        // { name: "目标检测", value: 150 },
      ],
    };
  },
  mounted() {
    this.drawCloud(this.$refs.cloudEl, this.wordcloudData);
    window.addEventListener("resize", this.handleResize);
    if (typeof ResizeObserver !== "undefined" && this.$refs.cloudEl) {
      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this.$refs.cloudEl);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.myChart) {
      this.myChart.dispose();
      this.myChart = null;
    }
  },

  methods: {
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    drawCloud(wrapEl, data) {
      if (!wrapEl) {
        return;
      }
      if (!this.myChart) {
        this.myChart = echarts.init(wrapEl);
      }
      var option = {
        tooltip: {
          show: true,
        },
        series: [
          {
            type: "wordCloud",
            keepAspect: false, //不保持词云图的纵横比
            sizeRange: [12, 40], //词云图中词语的字体大小范围，最小12px，最大60px
            rotationRange: [-90, 90], //词云图中词语的旋转角度范围
            rotationStep: 45, //词云图中词语的旋转步长
            shape: "circle",
            drawOutOfBound: false, // 控制词云图是否允许词语超出绘制区域
            left: "center",
            top: "center",
            width: "100%",
            height: "100%",
            gridSize: 10,
            textPadding: 0,
            layoutAnimation: true, //开启布局动画

            textStyle: {
              color: function () {
                return "rgb(" + Math.round(Math.random() * 255) + "," + Math.round(Math.random() * 255) + "," + Math.round(Math.random() * 255) + ")";
              },
            },
            data: data,
          },
        ],
      };
      this.myChart.setOption(option, true);
      this.myChart.off("click");
      this.myChart.on("click", params => {
        if (params.componentType === "series" && params.seriesType === "wordCloud") {
          // 这里可以处理点击事件，例如显示一个弹窗或执行其他操作

          this.$emit("wordcloud-event", params);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wordcloud-container {
  width: 100%;
  .cloud-box {
    width: 100%;
    height: 400px;
  }
}
</style>
